// extracted by mini-css-extract-plugin
module.exports = {"cell":"UploadFloorPlanTable_cell_11KJ-"};